import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AccessModuleServiceService } from '../services/access-module-service.service';

@Injectable({ providedIn: 'root' })
export class moduleGuard implements CanActivate {

  constructor(private _authService: AuthService, private _accessControlService: AccessModuleServiceService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUser = this._authService.getCurrentUser();

    if (currentUser) {
      const requiredModules = route.data['modules'] || [];
      const role_name = currentUser?.role_name;
      const requiredRoles = route.data['roles'] || [];
      const hasModuleAccess = requiredModules.every((module: string) => currentUser.module_permissions?.[module]?.read);
      const hasRoleAccess = requiredRoles.length === 0 || requiredRoles.some((role: string) => this.isRole(role_name, role));
      const hasAccess = hasModuleAccess && hasRoleAccess;

      if (hasAccess) {
        this._accessControlService.setAccess(true);
        this._accessControlService.setRoleName(role_name);
        return true;
      } else {
        this._accessControlService.setAccess(false);
        this._accessControlService.setRoleName(role_name);
        return true; 
      }
    } else {
      this._authService.logout();
    }

    return false;
  }

  private isRole(currentRole: string | undefined, expectedRole: string): boolean {
    return currentRole?.toLowerCase() === expectedRole.toLowerCase();
  }
}
